/*
 * Public API Surface of ngx-lib
 */
export * from './ngx-lib.module';
export * from './core/index';
